// extracted by mini-css-extract-plugin
export default {"wrapper":"input-time_wrapper__vg347","label":"input-time_label__HHJfV","periodWrapper":"input-time_periodWrapper__XkXAA"};